(function () {
  if (window.CPAvailabilityCartGuard) return;

  const availableTagPattern = /^available:\s*([a-z]+)-(\d{4})$/i;
  const monthIndexes = {
    january: 1,
    february: 2,
    march: 3,
    april: 4,
    may: 5,
    june: 6,
    july: 7,
    august: 8,
    september: 9,
    october: 10,
    november: 11,
    december: 12,
  };
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const originalFetch = window.fetch.bind(window);
  const productTagCache = new Map();
  let lastActiveElement = null;

  const ensurePopup = () => {
    let popup = document.getElementById('CPAvailabilityCartGuardPopup');
    if (popup) return popup;

    const style = document.createElement('style');
    style.textContent = `
      .cp-availability-popup {
        position: fixed;
        inset: 0;
        z-index: 2147483647;
        display: grid;
        place-items: center;
        padding: 2rem;
        background: rgba(18, 27, 22, 0.46);
      }

      .cp-availability-popup[hidden] {
        display: none;
      }

      .cp-availability-popup__dialog {
        width: min(100%, 46rem);
        padding: 2.8rem;
        border-radius: 0.8rem;
        background: #ffffff;
        color: #1f2c25;
        box-shadow: 0 2.4rem 6rem rgba(0, 0, 0, 0.24);
        font-family: inherit;
        text-align: center;
      }

      .cp-availability-popup__title {
        margin: 0 0 1rem;
        color: #123b23;
        font-size: 2.2rem;
        line-height: 1.2;
      }

      .cp-availability-popup__message {
        margin: 0 0 2rem;
        font-size: 1.55rem;
        line-height: 1.45;
      }

      .cp-availability-popup__close {
        min-width: 12rem;
        min-height: 4.4rem;
        padding: 1rem 1.8rem;
        border: 0;
        border-radius: 0.6rem;
        background: #123b23;
        color: #ffffff;
        cursor: pointer;
        font: inherit;
        font-weight: 700;
      }
    `;
    document.head.appendChild(style);

    popup = document.createElement('div');
    popup.id = 'CPAvailabilityCartGuardPopup';
    popup.className = 'cp-availability-popup';
    popup.hidden = true;
    popup.innerHTML = `
      <div class="cp-availability-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="CPAvailabilityCartGuardTitle" aria-describedby="CPAvailabilityCartGuardMessage" tabindex="-1">
        <h2 id="CPAvailabilityCartGuardTitle" class="cp-availability-popup__title">One Month at a Time</h2>
        <p id="CPAvailabilityCartGuardMessage" class="cp-availability-popup__message"></p>
        <button type="button" class="cp-availability-popup__close">Got it</button>
      </div>
    `;
    document.body.appendChild(popup);

    const closePopup = () => {
      popup.hidden = true;
      document.documentElement.classList.remove('cp-availability-popup-open');
      if (lastActiveElement && typeof lastActiveElement.focus === 'function') lastActiveElement.focus();
    };

    popup.addEventListener('click', (event) => {
      if (event.target === popup || event.target.closest('.cp-availability-popup__close')) closePopup();
    });

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePopup();
    });

    return popup;
  };

  const showBlockedPopup = (message) => {
    if (!document.body) return;

    const popup = ensurePopup();
    const messageEl = popup.querySelector('#CPAvailabilityCartGuardMessage');
    const dialog = popup.querySelector('.cp-availability-popup__dialog');
    if (messageEl) messageEl.textContent = message;

    lastActiveElement = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('cp-availability-popup-open');
    window.requestAnimationFrame(() => {
      const closeButton = popup.querySelector('.cp-availability-popup__close');
      if (closeButton && typeof closeButton.focus === 'function') closeButton.focus();
      else if (dialog && typeof dialog.focus === 'function') dialog.focus();
    });
  };

  const buildMonthTag = (year, month) => {
    const label = `${monthNames[month - 1]}-${year}`;
    return {
      key: `${year}-${String(month).padStart(2, '0')}`,
      label,
      tag: `available: ${label}`,
    };
  };

  const getCurrentMonthTag = () => {
    const configuredTag = normalizeTag(window.CPAvailabilityCartGuardSettings?.currentMonthTag);
    if (configuredTag) return configuredTag;

    const now = new Date();
    return buildMonthTag(now.getFullYear(), now.getMonth() + 1);
  };

  const normalizeTag = (tag) => {
    const rawTag = String(tag || '').trim();
    if (rawTag.toLowerCase() === 'available: always') return null;

    const match = rawTag.match(availableTagPattern);
    if (!match) return null;

    const monthName = match[1].toLowerCase();
    const month = monthIndexes[monthName];
    const year = Number(match[2]);
    if (!month || !year) return null;

    const label = `${monthName.charAt(0).toUpperCase()}${monthName.slice(1)}-${year}`;
    return {
      key: `${year}-${String(month).padStart(2, '0')}`,
      label,
      tag: `available: ${label}`,
    };
  };

  const toTagList = (tags) => {
    if (Array.isArray(tags)) return tags;
    return String(tags || '')
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
  };

  const isAlwaysAvailable = (tags) =>
    toTagList(tags).some((tag) => String(tag || '').trim().toLowerCase() === 'available: always');

  const findAvailableTag = (tags) => {
    if (!tags) return null;

    const tagList = toTagList(tags);

    if (isAlwaysAvailable(tagList)) return null;

    for (const tag of tagList) {
      const normalized = normalizeTag(tag);
      if (normalized) return normalized;
    }

    return null;
  };

  const getRequestedFulfillmentTag = (requestedTag = '') => {
    let rawTag = String(requestedTag || '').trim();
    if (!rawTag && typeof window.location?.search === 'string') {
      rawTag = new URLSearchParams(window.location.search).get('fulfillment_month') || '';
    }

    const normalized = normalizeTag(rawTag);
    if (!normalized) return null;

    const current = getCurrentMonthTag();
    const [currentYear, currentMonth] = current.key.split('-').map(Number);
    const [requestedYear, requestedMonth] = normalized.key.split('-').map(Number);
    const monthDistance = (requestedYear - currentYear) * 12 + requestedMonth - currentMonth;
    return monthDistance >= 0 && monthDistance <= 2 ? normalized : null;
  };

  const resolveFulfillmentTag = (tags, requestedTag = '') => {
    const datedTag = findAvailableTag(tags);
    if (datedTag) return datedTag;
    if (!isAlwaysAvailable(tags)) return null;
    return getRequestedFulfillmentTag(requestedTag) || getCurrentMonthTag();
  };

  const mergeProperties = (properties, availableTag) => {
    const normalized = normalizeTag(availableTag);
    if (!normalized) return properties || {};

    return {
      ...(properties || {}),
      _available_month: normalized.tag,
    };
  };

  const buildLineProperties = (properties, tags, requestedTag = '') => {
    const availableTag = findAvailableTag(tags);
    const fulfillmentTag = resolveFulfillmentTag(tags, requestedTag);
    return {
      ...(properties || {}),
      ...(availableTag ? { _available_month: availableTag.tag } : {}),
      ...(fulfillmentTag ? { _menu_context_month: fulfillmentTag.tag } : {}),
    };
  };

  const getUrlPath = (input) => {
    const rawUrl = typeof input === 'string' ? input : input?.url;
    if (!rawUrl) return '';

    try {
      return new URL(rawUrl, window.location.origin).pathname;
    } catch (error) {
      return String(rawUrl);
    }
  };

  const isCartAddRequest = (input, init = {}) => {
    const method = String(init?.method || input?.method || 'GET').toUpperCase();
    if (method && method !== 'POST') return false;

    const path = getUrlPath(input);
    return /\/cart\/add(?:\.js)?$/i.test(path);
  };

  const getCartChangeUrl = () => window.routes?.cart_change_url || '/cart/change.js';

  const extractPropertyFromFormData = (formData, itemIndex, propertyName) =>
    formData.get(`items[${itemIndex}][properties][${propertyName}]`) || formData.get(`properties[${propertyName}]`);

  const extractItemsFromBody = (body) => {
    if (!body) return [];

    if (body instanceof FormData) {
      const indexedIds = [];
      body.forEach((value, key) => {
        const match = String(key || '').match(/^items\[(\d+)\]\[id\]$/);
        if (match) indexedIds[Number(match[1])] = value;
      });

      if (indexedIds.length) {
        return indexedIds
          .map((id, index) => ({
            id: String(id || '').trim(),
            availableTag: extractPropertyFromFormData(body, index, '_available_month'),
            fulfillmentTag: extractPropertyFromFormData(body, index, '_menu_context_month'),
          }))
          .filter((item) => item.id);
      }

      const id = body.get('id');
      return id
        ? [
            {
              id: String(id || '').trim(),
              availableTag: body.get('properties[_available_month]'),
              fulfillmentTag: body.get('properties[_menu_context_month]'),
            },
          ]
        : [];
    }

    if (typeof body === 'string') {
      try {
        const payload = JSON.parse(body);
        const items = Array.isArray(payload?.items) ? payload.items : [payload];
        return items
          .map((item) => ({
            id: String(item?.id || '').trim(),
            availableTag: item?.properties?._available_month,
            fulfillmentTag: item?.properties?._menu_context_month,
          }))
          .filter((item) => item.id);
      } catch (error) {
        return [];
      }
    }

    return [];
  };

  const fetchProductTagByHandle = async (handle) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return null;
    if (productTagCache.has(normalizedHandle)) return productTagCache.get(normalizedHandle);

    try {
      const rootUrl = window.routes?.root_url || '/';
      const response = await originalFetch(`${rootUrl}products/${normalizedHandle}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Product lookup failed.');

      const product = await response.json();
      const availableTag = findAvailableTag(product?.tags);
      productTagCache.set(normalizedHandle, availableTag);
      return availableTag;
    } catch (error) {
      productTagCache.set(normalizedHandle, null);
      return null;
    }
  };

  const getCartAvailableTags = async (cartSnapshot = null) => {
    let cart = cartSnapshot;
    if (!cart) {
      const response = await originalFetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js', {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return [];
      cart = await response.json();
    }
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const tags = [];

    for (const item of items) {
      const fulfillmentTag = normalizeTag(item?.properties?._menu_context_month);
      const propertyTag = normalizeTag(item?.properties?._available_month);
      if (propertyTag && fulfillmentTag) {
        tags.push(propertyTag);
        continue;
      }
      if (fulfillmentTag && !propertyTag) continue;

      const productTag = await fetchProductTagByHandle(item?.handle);
      if (productTag) tags.push(productTag);
    }

    return tags;
  };

  const getCartSnapshot = async () => {
    const response = await originalFetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js', {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Could not load the cart fulfillment month.');
    return response.json();
  };

  const formatFulfillmentMonth = (monthTag) => String(monthTag?.label || '').replace('-', ' ').trim();

  const prepareCartFulfillmentMonth = async (body) => {
    const incomingItems = extractItemsFromBody(body);
    const incomingHasMealAvailability = incomingItems.some((item) => item.availableTag || item.fulfillmentTag);
    if (!incomingHasMealAvailability) return null;

    const cart = await getCartSnapshot();

    const datedTags = await getCartAvailableTags(cart);
    const incomingAvailableTag = incomingItems
      .map((item) => normalizeTag(item.availableTag))
      .find(Boolean);
    const incomingFulfillmentTag = incomingItems
      .map((item) => normalizeTag(item.fulfillmentTag))
      .find(Boolean);
    const fulfillmentTag = datedTags[0] || incomingAvailableTag || incomingFulfillmentTag || getCurrentMonthTag();
    const fulfillmentMonth = formatFulfillmentMonth(fulfillmentTag);
    if (!fulfillmentMonth) return null;

    const attributeName = String(
      window.CPAvailabilityCartGuardSettings?.fulfillmentMonthAttribute || 'Fulfillment month'
    ).trim();
    const currentAttribute = String(cart.attributes?.[attributeName] || '').trim();
    if (currentAttribute === fulfillmentMonth) return null;

    const updateUrl = window.routes?.cart_update_url || `${window.routes?.root_url || '/'}cart/update.js`;
    const response = await originalFetch(updateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeName]: fulfillmentMonth,
        },
      }),
    });
    if (!response.ok) throw new Error('Could not save the cart fulfillment month.');
    return { attributeName, previousValue: currentAttribute, updateUrl };
  };

  const restoreCartFulfillmentMonth = async (preparedAttribute) => {
    if (!preparedAttribute) return;
    await originalFetch(preparedAttribute.updateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [preparedAttribute.attributeName]: preparedAttribute.previousValue,
        },
      }),
    }).catch(() => null);
  };

  const buildBlockedMessage = (cartTag, incomingTag) =>
    `Meals from ${incomingTag.label} cannot be added while your cart contains meals from ${cartTag.label}. Please either checkout with or remove ${cartTag.label} meals in order to add ${incomingTag.label} meals to your cart.`;

  const findMixedMonthConflict = (tags) => {
    if (!Array.isArray(tags) || tags.length < 2) return null;

    const firstTag = tags[0];
    const conflictingTag = tags.find((tag) => tag.key !== firstTag.key);
    return conflictingTag
      ? {
          cartTag: firstTag,
          incomingTag: conflictingTag,
        }
      : null;
  };

  const blockedResponse = (message) =>
    new Response(JSON.stringify({ status: 422, message, description: message, availabilityCartGuard: true }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' },
    });

  const getAddedLineKeys = (responseJson) => {
    const items = Array.isArray(responseJson?.items) ? responseJson.items : [responseJson];
    return items
      .map((item) => String(item?.key || '').trim())
      .filter(Boolean);
  };

  const rollbackAddedLines = async (lineKeys) => {
    for (const lineKey of lineKeys) {
      await originalFetch(getCartChangeUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      }).catch(() => null);
    }
  };

  const parseJsonResponse = async (response) => {
    try {
      return await response.clone().json();
    } catch (error) {
      return null;
    }
  };

  const validateCartAdd = async (body) => {
    const incomingTags = extractItemsFromBody(body)
      .map((item) => normalizeTag(item.availableTag))
      .filter(Boolean);

    if (!incomingTags.length) return null;

    const firstIncomingTag = incomingTags[0];
    const mixedIncomingTag = incomingTags.find((tag) => tag.key !== firstIncomingTag.key);
    if (mixedIncomingTag) return buildBlockedMessage(firstIncomingTag, mixedIncomingTag);

    const cartTags = await getCartAvailableTags();
    const conflictingCartTag = cartTags.find((tag) => tag.key !== firstIncomingTag.key);
    return conflictingCartTag ? buildBlockedMessage(conflictingCartTag, firstIncomingTag) : null;
  };

  window.CPAvailabilityCartGuard = {
    buildLineProperties,
    findAvailableTag,
    isAlwaysAvailable,
    mergeProperties,
    resolveFulfillmentTag,
  };

  window.fetch = async function guardedFetch(input, init = {}) {
    if (isCartAddRequest(input, init)) {
      const body = init?.body || input?.body;
      const blockedMessage = await validateCartAdd(body);
      if (blockedMessage) {
        showBlockedPopup(blockedMessage);
        return blockedResponse(blockedMessage);
      }

      let preparedAttribute;
      try {
        preparedAttribute = await prepareCartFulfillmentMonth(body);
      } catch (error) {
        console.error('[CP availability] Failed to prepare fulfillment month:', error);
        const message = 'We could not set the fulfillment month for this meal. Please try adding it again.';
        showBlockedPopup(message);
        return blockedResponse(message);
      }

      let response;
      try {
        response = await originalFetch(input, init);
      } catch (error) {
        await restoreCartFulfillmentMonth(preparedAttribute);
        throw error;
      }
      if (!response.ok) {
        await restoreCartFulfillmentMonth(preparedAttribute);
        return response;
      }

      const responseJson = await parseJsonResponse(response);
      const addedLineKeys = getAddedLineKeys(responseJson);
      if (!addedLineKeys.length) {
        await restoreCartFulfillmentMonth(preparedAttribute);
        return response;
      }

      const cartConflict = findMixedMonthConflict(await getCartAvailableTags());
      if (cartConflict) {
        await rollbackAddedLines(addedLineKeys);
        await restoreCartFulfillmentMonth(preparedAttribute);
        const message = buildBlockedMessage(cartConflict.cartTag, cartConflict.incomingTag);
        showBlockedPopup(message);
        return blockedResponse(message);
      }

      return response;
    }

    return originalFetch(input, init);
  };
})();
